import {
  ICartLocationHistory,
  ISortCartResultModel,
} from "../../interfaces/SortCart/ISortCartResultModel";
import { IPayloadWrapper } from "./PayloadWrapper";

export const SET_CART_SUGGESTION = "automatpacken/cart/SET_CART_SUGGESTION";
export const SET_CART_ID = "automatpacken/cart/SET_CART_ID";
export const SET_CART_DATA = "automatpacken/cart/SET_CART_DATA";
export const CLEAR_CART_STATE = "automatpacken/cart/CLEAR_CART_STATE";
export const SCAN_CART_ID = "automatpacken/cart/SCAN_CART_ID";
export const SET_FORCE_CART = "automatpacken/cart/SET_FORCE_CART";
export const SET_CART_TYPE = "automatpacken/cart/SET_CART_TYPE";
export const SET_COMPANY_ID = "automatpacken/cart/SET_COMPANY_ID";
export const FETCH_CART_DATA = "automatpacken/cart/FETCH_CART_DATA";
export const SET_RX_ENABLED = "automatpacken/cart/SET_RX_ENABLED";

export const SET_SORT_ID = "automatpacken/cart/SET_SORT_ID";
export const HANDLE_CART_FAILURE_RESPONSE = "automatpacken/cart/HANDLE_CART_FAILURE_RESPONSE";

interface SetRXEnabled {
  type: typeof SET_RX_ENABLED;
  payload: IPayloadWrapper<boolean>;
}

interface SetCartData {
  type: typeof SET_CART_DATA;
  payload: ISortCartResultModel;
  meta: { setCart: () => void };
}

interface SetSortID {
  type: typeof SET_SORT_ID;
  payload: IPayloadWrapper<number>;
}

interface SetCartSuggestion {
  type: typeof SET_CART_SUGGESTION;
  payload: IPayloadWrapper<number>;
}

interface SetCartID {
  type: typeof SET_CART_ID;
  payload: IPayloadWrapper<number>;
}

interface ScanCartID {
  type: typeof SCAN_CART_ID;
  payload: IPayloadWrapper<string>;
}

interface ClearCartState {
  type: typeof CLEAR_CART_STATE;
}

interface SetForceCart {
  type: typeof SET_FORCE_CART;
  payload: IPayloadWrapper<boolean>;
}

interface SetCartType {
  type: typeof SET_CART_TYPE;
  payload: IPayloadWrapper<number>;
}

interface SetCompanyID {
  type: typeof SET_COMPANY_ID;
  payload: IPayloadWrapper<number>;
}

interface FetchCartData {
  type: typeof FETCH_CART_DATA;
  payload: { setCart: () => void; showInstruction: () => void };
}

interface HandleCartFailureResponse {
  type: typeof HANDLE_CART_FAILURE_RESPONSE;
  payload: ISortCartResultModel;
  meta: { showInstruction: () => void; showWarningModal: () => void };
}

export interface CartState {
  cartSuggestion: number;
  currentCart: number;
  cartType: number;
  sortType: number;
  rxEnabled: boolean;
  isRXSingle: boolean;
  sortID: number;
  isSingleCart: boolean;
  isMultiCart: boolean;
  forceCart: boolean;
  companyID: number;
  workstationType: number;
  locationHistory: ICartLocationHistory[];
  hasHelpPicklist: boolean;
}

export type CartActionTypes =
  | SetCartData
  | SetCartSuggestion
  | SetCartID
  | ClearCartState
  | ScanCartID
  | SetForceCart
  | SetCartType
  | SetCompanyID
  | FetchCartData
  | SetSortID
  | HandleCartFailureResponse
  | SetRXEnabled;
